<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph">Copyright © 2015</p>
<p class="Basic-Paragraph">By Jeff Dwyer</p>
<p class="Basic-Paragraph">All rights reserved</p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-6">The word “Pelican” and the depiction of a pelican are</span></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-6">trademarks of Pelican Publishing Company, Inc., and are</span></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-6">registered in the U.S. Patent and Trademark Office.</span></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph">ISBN 9781455621163</p>
<p class="Basic-Paragraph">E-book ISBN 9781455621170</p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<div class="frame-2a" style="text-align: left;"><img alt="copyrightv2.jpg" src="Images/copyrightv2.jpg.jpg"/></div>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-5">Printed in the United States of America</p>
<p class="Basic-Paragraph">Published by Pelican Publishing Company, Inc.</p>
<p class="Basic-Paragraph para-style-override-6">1000 Burmaster Street, Gretna, Louisiana 70053</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?536fa50d